export default function TableHeading({ headings }: { headings: any }) {
  return (
    <thead className="text-nowrap">
      <tr>
        {headings?.map((heading: any, index: any) => (
          <th
            style={{
              textAlign: heading?.align
            }}
            key={index}
          >
            {heading?.label}
          </th>
        ))}
      </tr>
    </thead>
  );
}
